const { fetcher, endpoints } = require('src/utils/axios');
const { default: useSWR } = require('swr');

const useCountries = () =>
  useSWR(endpoints.common.getCountries, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false,
  });

export default useCountries;
